var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdminPartnerPortal = function SvgAdminPartnerPortal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.357.975s3.482 0 3.482 3.482 0 3.482-3.482 3.482-3.482 0-3.482-3.482S.875.975 4.357.975ZM10.225 4.094c.05-1.733 1.317-3.102 3.05-3.118a40 40 0 0 1 .735 0c1.733.016 3.001 1.385 3.05 3.118.036 1.25.065 2.91.065 5.006s-.029 3.756-.064 5.005c-.05 1.733-1.318 3.102-3.05 3.118a40 40 0 0 1-.736 0c-1.733-.016-3-1.385-3.05-3.118-.035-1.25-.064-2.91-.064-5.005 0-2.096.029-3.757.064-5.006ZM4.357 10.26s3.482 0 3.482 3.482 0 3.482-3.482 3.482-3.482 0-3.482-3.482 0-3.482 3.482-3.482Z"
  }))));
};
export default SvgAdminPartnerPortal;